import { Button, Typography } from '@navi/web-ui/lib/primitives';
import InfoSolidSmallIcon from '@cp/src/assets/icons/InfoSolidSmallIcon';
import { Popper, PopperTrigger, PopperContent } from '@cp/src/components/Popper/Popper';
import styles from './index.module.scss';
import cx from 'classnames';
import AudioControls from '@cp/src/components/Waveform/AudioControls';
import LanPopper from './LanPopper';
import dayjs from 'dayjs';
import { DateTimeFormat } from '@cp/src/components/DateTimePicker/constants';
import { DateFormat } from '@cp/src/utils/DateHelper';

interface CallDetailsAddFeedbackProps {
  interactionData: any;
}

const CallDetailsAddFeedback = (props: CallDetailsAddFeedbackProps) => {
  const { interactionData } = props;

  const naviNumber = interactionData?.agentPhoneNumber || 'NA';
  const ownerName = interactionData?.metadata?.assigned_to || 'NA';
  const isMultipleLANsLinked = interactionData?.metadata?.isMultipleLANsLinked === 'true';
  const isPrimaryNumberOfAnotherLan =
    interactionData?.metadata?.isPrimaryNumberOfAnotherLan === 'true';

  const dateTimeStamp = interactionData?.createdAt;

  const callStartDateTime = Number(interactionData?.metadata?.START_TIMESTAMP_MS);

  const showPopper = isMultipleLANsLinked || isPrimaryNumberOfAnotherLan;

  const audioUrl: string = interactionData?.metadata?.recordingUrl;

  const audioMetaData: {
    interactionId: string;
    interactionCreatedAt: string;
    phoneNumber: string;
    callType: string;
  } = {
    interactionId: interactionData?.id,
    interactionCreatedAt: interactionData?.createdAt,
    phoneNumber: interactionData?.source?.recipientNumber,
    callType: interactionData?.type
  };

  return (
    <div className="mb-6">
      <div className="w-[290px] bg-[var(--grayscale-background-secondary)] justify-center flex flex-col p-4 gap-3 rounded-lg ">
        <div className="flex flex-row w-full align-center mb-3">
          <Typography
            variant="h4"
            color={'var(--navi-color-gray-c1)'}
            className=""
          >{`Self call details for ${interactionData?.source?.recipientNumber}`}</Typography>

          {showPopper ? (
            <Popper placement="bottom-start">
              <PopperTrigger>
                <Button
                  variant={'text'}
                  startAdornment={
                    <div className="ml-1.5 pt-[1px]">
                      <InfoSolidSmallIcon fill="var( --grayscale-3)" />
                    </div>
                  }
                >
                  {' '}
                </Button>
              </PopperTrigger>
              <PopperContent
                noHeader={true}
                className={cx('popperWrapper', 'z-[var(--z-index-ameyo-tooltip)] p-0')}
                arrowColor="var(--orange-oldlase)"
              >
                <div className={styles.popperContent}>
                  <LanPopper
                    isMultipleLANsLinked={isMultipleLANsLinked}
                    isPrimaryNumberOfAnotherLan={isPrimaryNumberOfAnotherLan}
                  />
                </div>
              </PopperContent>
            </Popper>
          ) : null}
        </div>

        <div className="flex flex-row gap-1 ">
          <Typography variant="p5" color={'var(--navi-color-gray-c3)'} className="w-[126px]">
            Navi Number
          </Typography>
          <Typography variant="p3" color={'var(--navi-color-gray-c2)'}>
            {naviNumber}
          </Typography>
        </div>
        <div className="flex flex-row gap-1 ">
          <Typography variant="p5" color={'var(--navi-color-gray-c3)'} className="w-[126px]">
            Assigned to
          </Typography>
          <Typography variant="p3" color={'var(--navi-color-gray-c2)'}>
            {ownerName}
          </Typography>
        </div>

        <div className="flex flex-row gap-1">
          <Typography variant="p5" color={'var(--navi-color-gray-c3)'} className="w-[126px]">
            Date & Time
          </Typography>
          <div className="flex">
            <Typography variant="p3" color={'var(--navi-color-gray-c2)'}>
              {dayjs(dateTimeStamp).format(DateFormat.DD_MMM_YYYY_hh_mm_a)}
            </Typography>
          </div>
        </div>

        <div className="flex flex-row">
          <Typography variant="p5" color={'var(--navi-color-gray-c3)'} className="w-[126px]">
            Time of Call
          </Typography>
          <div className="flex">
            <Typography variant="p3" color={'var(--navi-color-gray-c2)'}>
              {dayjs(callStartDateTime).format(DateFormat.DD_MMM_YYYY_hh_mm_a)}
            </Typography>
          </div>
        </div>

        <div className="flex flex-row gap-1 ">
          <Typography variant="p5" color={'var(--navi-color-gray-c3)'} className="w-[126px]">
            Recording
          </Typography>
          <div className="w-[150px]">
            <AudioControls audioUrl={audioUrl} metaData={audioMetaData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallDetailsAddFeedback;
